// see: https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/theme/src/components/radio.ts
export const radioTheme = {
    defaultProps: {
        colorScheme: 'primary',
    },
}
